export default (context, { number }) => {
    if(context.phone.length === 12) {
        context.phone = number
        context.inputValidate = true
    } else {
        context.inputValidate = false
    }
}